import * as ast from '../../generated/ast.js';
import { checkForDuplicateAndRequiredProperties } from '../../common/utilities.js';
import { FRONTEND_PROPERTY_NAME } from '../../common/constants.js';
export function validateSecure(nodeFields, accept) {
    const { idField, richAssetField } = nodeFields;
    if (!richAssetField || !ast.isRichAssetSecure(richAssetField?.content))
        return;
    if (ast.isStringField(richAssetField.content.value)) {
        // Add a deprecation warning
        accept('warning', `String content for secure is being deprecated. Please use the new JSON format.`, {
            node: richAssetField,
            data: {
                id: idField?.id?.value,
                nodeNumber: nodeFields.nodeNumber,
                propertyName: FRONTEND_PROPERTY_NAME.RICH_ASSET_CONTENT,
            },
        });
    }
    else if (ast.isSecureJson(richAssetField.content.value)) {
        const secureJson = richAssetField.content.value;
        // Check for duplicate and required properties
        checkForDuplicateAndRequiredProperties({
            node: secureJson,
            allProperties: secureJson.properties,
            requiredProperties: [ast.TypeStaticProperty, ast.MessageProperty],
            parentNode: nodeFields.refNode,
            accept,
        });
    }
}
//# sourceMappingURL=secure.js.map